module.exports = __webpack_public_path__ + "static/media/ic-added-pans.6138a289.svg";